// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__YHMAz","close":"style_close__E24cV","description":"style_description__MhItt","header":"style_header__Prybj","btn":"style_btn__c5EBC"};